import type { DeleteJob } from './undoableActionsCore';

/**
 * FIX-B10 (QA-P29 minor 1) - "הושלם" (`useCloseTicket`, tickets list and "היום שלי")
 * as a job of the ONE P-27 scheduler (`undoableDelete`), so a close still waiting in
 * its 6 s window leaves on pagehide / hidden tab as a `fetch` with `keepalive`
 * (same PATCH as `api.updateTicketStatus`) and is not lost with the page.
 * Pure: the caller passes the request and the callbacks.
 */
export const TICKET_CLOSE_KIND = 'ticket_close';

export interface CloseJobVars {
  id: string;
  cascade?: boolean;
}

export function buildCloseTicketJob(
  vars: CloseJobVars,
  o: {
    message: string;
    run: () => Promise<unknown>;
    onCommitted?: () => void;
    /** Undone or failed: the row is back. */
    onRestore?: () => void;
    onError?: (error: unknown) => void;
  },
): DeleteJob {
  return {
    kind: TICKET_CLOSE_KIND,
    id: vars.id,
    message: o.message,
    run: o.run,
    unload: {
      method: 'PATCH',
      path: `/tickets/${vars.id}/status`,
      body: { status: 'completed', ...(vars.cascade !== undefined && { cascade_close_subtasks: vars.cascade }) },
    },
    onCommitted: o.onCommitted,
    onRestore: o.onRestore,
    onError: o.onError,
  };
}
